export enum EGuideLineType {
  GLT_Default,
  GLT_ConveyorBelt,
}

export const EGuideLineTypeDisplayName = {
  [EGuideLineType.GLT_Default]: 'Default',
  [EGuideLineType.GLT_ConveyorBelt]: 'Conveyor Belt',
};
